import React from "react";
import { connect } from "react-redux";
import { reduxForm } from "redux-form";

import { activate } from "../../actions/userActions";

import Form from "../CustomViews/Form";

const PasswordForm = reduxForm({ form: "passwordForm" })(Form);

class Activate extends React.Component {
    onSubmit = (formValues, onFormError) => this.props.activate(this.props.match.params.token, formValues, error => {
        onFormError(error);
    });

    render() {
        const fields = [
            { name: "pass", type: "password", label: "Hasło:", placeholder:"Wpisz hasło...", autofocus: true },
            { name: "rpass", type: "password", label: "Potórz hasło:", placeholder:"Powtórz hasło..." }
        ];
        const pinFields = [
            { label: "Utwórz 6-cio cyfrowy PIN do potwierdzania operacji przez email" },
            { name: "pin", type: "password", label: "Pin:", placeholder:"Wpisz pin..." },
            { name: "rpin", type: "password", label: "Potórz pin:", placeholder:"Powtórz pin..." }
        ]

        return (
            <React.Fragment>
                <div className="ui secondary pointing menu">
                    <div className="ui container">
                        <h3 className="item">{this.props.operation === "activate" ? "Aktywuj konto" : "Utwórz nowe hasło"}</h3>
                    </div>
                </div>
                <div className="ui container">
                    {this.props.operation === "activate" ? (
                        <div className="ui header">
                            <div className="content">Utwórz nowe hasło</div>
                        </div>
                    ) : null}
                    <PasswordForm onSubmit={this.onSubmit} label="Potwierdź" fields={this.props.operation === "activate" ? [...fields, ...pinFields] : fields} />
                </div>
            </React.Fragment>
        );
    }
}


export default connect(null, { activate })(Activate);